/** The Compose service subdomain retains the current environment, root domain and port. */
export function buildDomainServiceUrl(
	hostname: string,
	port: string,
	service: string,
): string {
	const parts = hostname.split(".")
	const environment = parts.slice(1, -2)
	return `//${service}${environment.length ? `.${environment.join(".")}` : ""}.${parts.slice(-2).join(".")}${port ? `:${port}` : ""}`
}

/** Website snippets use the Widget v4 Traefik hostname from Compose, with no extra environment variable. */
export function getPublicWidgetUrl(): string {
	const { hostname, port, protocol } = window.location
	return `${protocol}${buildDomainServiceUrl(hostname, port, "widget-v4")}`
}

/** Customer installations keep the canonical CDN host; review builds select the existing environment's CDN service. */
export function getPublicCdnUrl(): string {
	const { hostname, port, protocol } = window.location
	// Review assets must come from the same feature stack as Widget v4, without adding another deployment variable.
	return hostname.split(".").includes("review")
		? `${protocol}${buildDomainServiceUrl(hostname, port, "cdn")}`
		: "//cdn.gbooking.ru"
}
